<style lang="scss">
.calls {
}
</style>

<!-- eslint-disable -->
<template>
  <section>
    <div class="row">
      <div class="col-sm-6">
        <call-overview show-cancel-button></call-overview>
        <basic-details></basic-details>
        <additional-visitors></additional-visitors>
        <payment-and-kiosk-items></payment-and-kiosk-items>
      </div>
      <div class="col-sm-6">
        <visitor-details :visitor_user_id="call.visitor.user_id"></visitor-details>
      </div>
    </div>
  </section>
</template>
<!-- eslint-enable -->

<script>
import { mapState } from 'vuex';
import BasicDetails from '@/views/calls/callDetails/sections/BasicDetails.vue';
import AdditionalVisitors from '@/views/calls/callDetails/sections/AdditionalVisitors';
import CallOverview from '@/views/calls/callDetails/sections/CallOverview.vue';
import VisitorDetails from '@/components/visitors/details/VisitorDetails.vue';
import PaymentAndKioskItems from '@/views/calls/callDetails/sections/PaymentAndKioskItems.vue';

export default {
  name: 'CallDetailsCancelled',
  components: {
    BasicDetails,
    AdditionalVisitors,
    CallOverview,
    VisitorDetails,
    PaymentAndKioskItems,
  },
  props: {},
  data() {
    return {
      loading: true,
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      prison: state => state.prison.prison,
      call: state => state.callDetails.call,
      additionalVisitors: state => state.callDetails.additionalVisitors,
    }),
  },
  mounted() {

  },
  methods: {

  },
}
</script>
